
import validator from 'validator';

const validateCreateNotification = (data) => {
    let errors = {};

    const {notification_type,notification_title,description, file} = data;

    if (validator.isEmpty(notification_type)) {
        errors.notification_type = '알림 유형을 선택하십시오';
    }
    if (validator.isEmpty(notification_title)) {
        errors.notification_title = '알림 제목을 입력하세요';
    }
    if (validator.isEmpty(description)) {
        errors.description = '설명을 입력하십시오';
    }
    // if (validator.isEmpty(edate)) {
    //     errors.edate = 'select coupon end date';
    // }
    if (validator.isEmpty(file)) {
        errors.file = '알림 이미지 선택';
    }
    // if (!validator.isURL(link)) {
    //     errors.link = '유효하지 않은 URL입니다';
    // }
    // if (validator.isEmpty(file)) {
    //     errors.file = '파일을 업로드 해주세요';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateCreateNotification;
